import { apiHelper,PromiseHandler } from "../redux/apiHelper"
const getAdminUsers=()=>PromiseHandler(apiHelper('get', '/api/admin/user/get-admins'))
const getRoles =()=>PromiseHandler(apiHelper('get', '/api/admin/role/list?status=true'))
const addAdminUser =(data)=>PromiseHandler(apiHelper('post', `/api/admin/user/signup`, data))
const getAdminUserById=(id)=>PromiseHandler(apiHelper('get', `/api/admin/user/get-admin/${id}`))
const updateAdminUserById=(id,data)=>PromiseHandler(apiHelper('post', `/api/admin/user/admin-user-update/${id}`,data))
const deleteAdminUserById =(id)=>PromiseHandler(apiHelper('post', `/api/admin/user/delete/${id}`))

export{deleteAdminUserById,updateAdminUserById,getAdminUserById,addAdminUser,getAdminUsers,getRoles}